import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c47af584")

_pushScopeId("data-v-c47af584")
const _hoisted_1 = { class: "main flex flex-column align-items-center justify-center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", null, "当前角色无权限进入该页面", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("返回首页")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_button = _resolveComponent("a-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_button, {
      type: "primary",
      onClick: _ctx.goBack
    }, {
      default: _withId(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
})